export const CONSENT_COOKIE_NAME = 'descripio-cookie-consent';
export const CONSENT_PREFS_KEY = 'descripio-cookie-preferences';

/**
 * Push a Consent Mode v2 update to GTM for the given analytics/marketing choices.
 * No-ops when window.gtag is unavailable (e.g. SSR, GTM not yet loaded).
 */
export function updateGtmConsent({ analytics, marketing }) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
}

/**
 * Read stored consent and push an update for returning users.
 * Mirrors the restore block in the layout.jsx inline script (which must stay
 * self-contained for synchronous pre-GTM execution). Keep in sync with that script.
 */
export function restoreGtmConsentFromStorage() {
  try {
    const savedConsent = document.cookie.split(';').some(
      (c) => c.trim().indexOf(CONSENT_COOKIE_NAME + '=') === 0
    );
    const savedPrefs = localStorage.getItem(CONSENT_PREFS_KEY);
    if (savedConsent && savedPrefs) {
      const prefs = JSON.parse(savedPrefs);
      updateGtmConsent({ analytics: !!prefs.analytics, marketing: !!prefs.marketing });
    }
  } catch {
    // Deny-safe: malformed prefs or restricted storage — leave defaults in place
  }
}
